module.exports = __webpack_public_path__ + "img/cover-doctor-web.93fae538.png";